import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

export function setupSwipers(selector = '[data-action="swiper"]') {
    const swiperComponents = document.querySelectorAll(selector);

    swiperComponents.forEach(swiperComponent => {
        const swiper = new Swiper(swiperComponent, {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 'auto', // Slide sizes are controlled with css - not here
            speed: 500,
            parallax: true,
            centeredSlides: false,
        });

        swiper.on('resize', () => {
            // The resize function is triggered afters swipers default init event, which is why this class is being added here to prevent prev/next buttons showing up on page load
            if (!swiperComponent.classList.contains('swiper--initialized')) {
                swiperComponent.classList.add('swiper--initialized');
            }

            if (swiper.isBeginning && swiper.isEnd || (swiper.params.centeredSlides && swiper.wrapperEl && swiper.wrapperEl.scrollWidth <= swiperContainer.scrollWidth)) {
                swiperComponent.classList.add('swiper--not-interactive');
                swiper.params.enabled = false;
                swiper.disable();
            } else {
                swiperComponent.classList.remove('swiper--not-interactive');
                swiper.params.enabled = true;
                swiper.enable();
            }
        });
    });
}
